import React from 'react';
import ic_instagram from '../assets/iconmonstr-instagram-12.svg';
import ic_twitter from '../assets/iconmonstr-twitter-2.svg';
import ic_facebook from '../assets/iconmonstr-facebook-2.svg';
import ic_phone from '../assets/phone.svg';
import ic_instagram_dark from '../assets/inst-icn-black.svg';
import ic_twitter_dark from '../assets/twitter-icn-black.svg';
import ic_facebook_dark from '../assets/fb-icn-black.svg';
import ic_phone_dark from '../assets/phone-icn-black.svg';
import ic_tiktok from '../assets/ic-tiktok.svg';
import ic_tiktok_dark from '../assets/ic-tiktok-dark.svg';
import decorate_mint from '../assets/decorate-mint.svg';
import mug_img from '../assets/mug-img@2x.png';
import mug_img_webp from '../assets/mug-img_2x.webp';
import mug_img_jp2 from '../assets/mug-img_2x.jp2';
import hand_img from '../assets/hand-img@2x.png';
import hand_img_webp from '../assets/hand-img_2x.webp';
import hand_img_jp2 from '../assets/hand-img_2x.jp2';
import coffee_tree from '../assets/coffee-tree-img.png';

import { BrowserRouter as Link, NavLink, useLocation } from "react-router-dom"

function Footer({ actvieNav }) {
  let location = useLocation();
  return (
    <section
      className={`footer d-flex mx-auto align-items-end align-items-lg-center justify-content-center mb-4 mb-lg-0 ${(location.pathname !== '/') ? 'footer-no-decorate' : ''}`
      }
    >
      {(location.pathname === '/') ?
        <React.Fragment>
          <div className="tea d-lg-none">
            <picture>
              <source
                srcSet={hand_img_webp}
                type="image/webp"
                className="hand" />
              <source
                srcSet={hand_img_jp2}
                type="image/jp2"
                className="hand" />
              <img
                alt=""
                src={hand_img}
                className="hand" />
            </picture>
            <picture>
              <source
                srcSet={mug_img_webp}
                type="image/webp"
                className="mug" />
              <source
                srcSet={mug_img_jp2}
                type="image/jp2"
                className="mug" />
              <img
                alt=""
                src={mug_img}
                className="mug" />
            </picture>
            <div className="red-circle"></div>
          </div>
          <img src={decorate_mint} className="decorate-mint d-lg-none" alt="" />
        </React.Fragment>
        :
        ''}
      {(location.pathname === '/products') ? <img className="image-bottom d-none d-lg-block" src={coffee_tree} alt="" /> : ''}
      <div className={`footer-links d-lg-flex justify-content-between px-3`}>
        <ul className="p-0 d-lg-flex justify-content-between m-lg-0">
          <li className="pr-lg-5">
            <NavLink to="/" exact>{actvieNav[0]}</NavLink>
          </li>
          <li className="pr-lg-5">
            <NavLink to="/branches" exact>{actvieNav[1]}</NavLink>
          </li>
          <li className="pr-lg-5">
            <NavLink to="/products" exact>{actvieNav[2]}</NavLink>
          </li>
          <li>
            <NavLink to="/contactus" exact>{actvieNav[3]}</NavLink>
          </li>
          <li className="pl-lg-5">
            <a href="tel:0502662288">{actvieNav[4]}</a>
          </li>
        </ul>
        <ul className="d-flex justify-content-center p-0 m-lg-0">
          <li className="px-3 px-lg-3"><a href="https://twitter.com/javatimeinc" target="_blank" rel="noopener noreferrer"><img src={(location.pathname === '/contactus') ? ic_twitter_dark : ic_twitter} alt="twitter icon" /></a></li>
          <li className="px-3 px-lg-3"><a href="https://www.instagram.com/javatimeinc" target="_blank" rel="noopener noreferrer"><img src={(location.pathname === '/contactus') ? ic_instagram_dark : ic_instagram} alt="instagram icon" /></a></li>
          <li className="px-3 px-lg-3"><a href="https://www.tiktok.com/@javatimeinc" target="_blank" rel="noopener noreferrer"><img src={(location.pathname === '/contactus') ? ic_tiktok_dark : ic_tiktok} alt="tiktok icon" /></a></li>
        </ul>
      </div>
    </section>
  )
}
export default Footer;
